import script from "./SearchSubscriptionInput.vue?vue&type=script&setup=true&lang=js"
export * from "./SearchSubscriptionInput.vue?vue&type=script&setup=true&lang=js"

import "./SearchSubscriptionInput.vue?vue&type=style&index=0&id=c07b454e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c07b454e"]])

export default __exports__